import React from 'react';
import PropTypes from 'prop-types';


const EmployeesTableCell = ({ field, employee, handleOpenViewModal }) => {
  if (field.key === 'actions') {
    return (
      <td className="px-4 py-2">
        <div className="flex space-x-2">
          <button className="text-sss-info mr-2" onClick={() => handleOpenViewModal(employee.id)}>
            View
          </button>
        </div>
      </td>
    );
  }

  return (
    <td className="px-4 py-2">
        {employee[field.key] !== null ? employee[field.key] : '-'}
    </td>
  );
};

EmployeesTableCell.propTypes = {
  field: PropTypes.object.isRequired,
  employee: PropTypes.object.isRequired,
  handleOpenViewModal: PropTypes.func.isRequired,
};

export default EmployeesTableCell;
